import type { Brand } from "../../aysa_api/models/brand.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";
import type { Long } from "protoc-gen-ts";

export const createBaseBrand = (): Brand => {
  return {
    id: 0,
    name: "",
    path: "",

    deprecatedSquareImage: createBaseImage(),
    deprecatedPortraitImage: createBaseImage(),
    deprecatedLandscapeImage: createBaseImage(),
    slug: "",
  };
};

export const decodeBrand = (reader: Reader, length: number): Brand => {
  const end = reader.pos + length;
  const message = createBaseBrand();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.id = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.name = reader.string();

        break;
      case 3:
        message.path = reader.string();

        break;
      case 4:
        message.blackLogoImage = decodeImage(reader, reader.uint32());

        break;
      case 5:
        message.deprecatedWhiteLogoImage = decodeImage(reader, reader.uint32());

        break;
      case 6:
        message.deprecatedSquareImage = decodeImage(reader, reader.uint32());

        break;
      case 7:
        message.deprecatedPortraitImage = decodeImage(reader, reader.uint32());

        break;
      case 8:
        message.deprecatedLandscapeImage = decodeImage(reader, reader.uint32());

        break;
      case 9:
        message.slug = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeBrand = (writer: Writer, message: Brand): Writer => {
  writer.uint32(8).int64(message.id);
  writer.uint32(18).string(message.name);
  writer.uint32(26).string(message.path);
  if (message.blackLogoImage !== undefined) {
    encodeImage(writer.uint32(34).fork(), message.blackLogoImage).ldelim();
  }
  if (message.deprecatedWhiteLogoImage !== undefined) {
    encodeImage(
      writer.uint32(42).fork(),
      message.deprecatedWhiteLogoImage
    ).ldelim();
  }
  encodeImage(writer.uint32(50).fork(), message.deprecatedSquareImage).ldelim();
  encodeImage(
    writer.uint32(58).fork(),
    message.deprecatedPortraitImage
  ).ldelim();
  encodeImage(
    writer.uint32(66).fork(),
    message.deprecatedLandscapeImage
  ).ldelim();
  writer.uint32(74).string(message.slug);

  return writer;
};
